<template>
  <div class="my-wallet-container">
    <div class="title">My Wallet</div>
    <div class="content">
      <div class="item">
        <div class="label">Total balance:</div>
        <div class="value">{{ amountFormated | formatWeiAmount }} BUNI</div>
      </div>
      <div class="item">
        <div class="label">Address:</div>
        <div class="value">
          <a :href="_etherscanLink" target="_blank">
            {{ sliceAddress(address, 10) }}
          </a>
          <img
            src="@/assets/icon/copy-icon.svg"
            alt="copy icon"
            @click="copyAddress()"
          />
        </div>
      </div>
    </div>
    <div class="btn-container">
      <div class="refresh-btn" @click="handleRefresh()">Refresh</div>
      <div class="logout-btn" @click="handleLogout()">Logout</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { sliceAddress } from '@/helpers';
import config from '@/config';

export default {
  components: {},
  computed: {
    ...mapState('auth', ['address', 'connector']),
    ...mapGetters('myAccount', ['myBuniBalance']),
    _etherscanLink() {
      return `${config.configWallet.explorer}/address/${this.address}`;
    },
    amountFormated() {
      return this.myBuniBalance;
    }
  },
  methods: {
    ...mapActions('auth', ['disconnect']),
    sliceAddress,
    handleRefresh() {
      localStorage.setItem('my_wallet', this.address);
      localStorage.setItem('connector', JSON.stringify(this.connector));
      this.$store.dispatch('myAccount/fetchBalances');
    },
    async handleLogout() {
      await this.disconnect();
      this.$emit('closeModal');
    },
    copyAddress() {
      navigator.clipboard.writeText(this.address);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.my-wallet-container {
  min-width: 500px;
  height: 306px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  padding: 15px;
  color: #354165;

  .title {
    color: #10172a;
    font-family: Inter-Bold;
    font-size: 20px;
    margin-bottom: 20px;
  }
  .content {
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-width: 440px;
      height: 44px;
      font-size: 16px;
      background: #eaeffb;
      border-radius: 6px;
      padding: 8px 18px;
      margin-bottom: 15px;
      .label {
        margin-right: 15px;
      }
      .value {
        color: #354165;
        font-family: Inter-Bold;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 18px;
          height: 18px;
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
    .item:last-child {
      margin-bottom: 0;
    }
  }

  .btn-container {
    display: flex;
    justify-content: center;
    margin-top: 1.875rem;
    div {
      width: 140px;
      height: 48px;
      padding: 12px 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border-radius: 6px;
      font-family: Inter-Medium;
      border: 1px solid #5b6ef5;
      margin: 0 8px;
      color: #5b6ef5;
    }
    .refresh-btn {
      &:hover {
        box-shadow: 0px 2px 4px 2px rgba(110, 110, 110, 0.4);
        -webkit-box-shadow: 0px 2px 4px 2px rgba(110, 110, 110, 0.4);
        -moz-box-shadow: 0px 2px 4px 2px rgba(110, 110, 110, 0.4);
      }
    }
    .logout-btn {
      &:hover {
        box-shadow: 0px 2px 4px 2px rgba(110, 110, 110, 0.4);
        -webkit-box-shadow: 0px 2px 4px 2px rgba(110, 110, 110, 0.4);
        -moz-box-shadow: 0px 2px 4px 2px rgba(110, 110, 110, 0.4);
      }
    }
    .add-fund-btn {
      &:hover {
        box-shadow: 0px 2px 4px 2px rgba(110, 110, 110, 0.4);
        -webkit-box-shadow: 0px 2px 4px 2px rgba(110, 110, 110, 0.4);
        -moz-box-shadow: 0px 2px 4px 2px rgba(110, 110, 110, 0.4);
      }
    }
  }
}

@media (max-width: $breakpoint-mobile) {
  .my-wallet-container {
    min-width: 100%;
    .content {
      width: 100%;
      padding: 0;
      .item {
        font-size: 13px;
        min-width: 100%;
      }
    }
  }
}
</style>
